// extracted by mini-css-extract-plugin
module.exports = {"landing":"landing_landing__165QG","container":"landing_container__2WKso","bienvenido":"landing_bienvenido__1A9S4","boton":"landing_boton__13fhX"};